if (!customElements.get('voice-message')) {
  class VoiceMessage extends HTMLElement {
    connectedCallback() {
      this.audio = this.querySelector('audio');
      this.toggleButton = this.querySelector('.voice-message__toggle');
      this.waveform = this.querySelector('.voice-message__waveform');
      this.bars = Array.from(this.querySelectorAll('.voice-message__bar'));
      this.currentElement = this.querySelector('.voice-message__current');
      this.durationElement = this.querySelector('.voice-message__duration');

      this.toggleButton.addEventListener('click', () => this.toggle());
      this.waveform.addEventListener('pointerdown', (event) => this.seekFromPointer(event));
      this.waveform.addEventListener('keydown', (event) => this.seekFromKeyboard(event));

      this.audio.addEventListener('loadedmetadata', () => this.render());
      this.audio.addEventListener('durationchange', () => this.render());
      this.audio.addEventListener('timeupdate', () => this.render());
      this.audio.addEventListener('play', () => this.onPlay());
      this.audio.addEventListener('pause', () => this.onPause());
      this.audio.addEventListener('ended', () => this.reset());

      this.render();
    }

    get duration() {
      return Number.isFinite(this.audio.duration) ? this.audio.duration : 0;
    }

    toggle() {
      if (this.audio.paused) {
        document.querySelectorAll('voice-message audio').forEach((audio) => audio !== this.audio && audio.pause());
        this.audio.play().catch(() => this.onPause());
      } else {
        this.audio.pause();
      }
    }

    onPlay() {
      this.setAttribute('active', '');
      this.setAttribute('playing', '');
      this.toggleButton.setAttribute('aria-pressed', 'true');
      this.waveform.tabIndex = 0;
    }

    onPause() {
      this.removeAttribute('playing');
      this.toggleButton.setAttribute('aria-pressed', 'false');
    }

    reset() {
      this.onPause();
      this.removeAttribute('active');
      this.waveform.tabIndex = -1;
      this.audio.currentTime = 0;
      this.render();
    }

    seekTo(ratio) {
      if (!this.duration) return;
      this.audio.currentTime = Math.min(Math.max(ratio, 0), 1) * this.duration;
      this.render();
    }

    seekFromPointer(event) {
      const rect = this.waveform.getBoundingClientRect();
      const offset = document.dir === 'rtl' ? rect.right - event.clientX : event.clientX - rect.left;
      this.seekTo(offset / rect.width);
    }

    seekFromKeyboard(event) {
      const step = { ArrowRight: 5, ArrowUp: 5, ArrowLeft: -5, ArrowDown: -5 }[event.key];
      if (!step || !this.duration) return;
      event.preventDefault();
      this.seekTo((this.audio.currentTime + step) / this.duration);
    }

    render() {
      const progress = this.duration ? this.audio.currentTime / this.duration : 0;
      const playedBars = Math.round(progress * this.bars.length);

      this.bars.forEach((bar, index) => bar.classList.toggle('is-played', index < playedBars));
      this.waveform.setAttribute('aria-valuenow', Math.round(progress * 100));
      this.waveform.setAttribute('aria-valuetext', `${this.formatTime(this.audio.currentTime)} / ${this.formatTime(this.duration)}`);
      this.currentElement.textContent = `${this.formatTime(this.audio.currentTime)} | `;
      this.durationElement.textContent = this.duration ? this.formatTime(this.duration) : '';
    }

    formatTime(seconds) {
      const total = Math.floor(seconds || 0);
      return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
    }
  }

  customElements.define('voice-message', VoiceMessage);
}
